import {
  BaseCssVarValue,
  GetCssVarByClass
} from '@/views/game/components/gameCardSuit/components/baseCssVarInject'

/** 方型卡片外层的cssVar基类 */
export abstract class _OuterBoxBase extends BaseCssVarValue {
  /** css的类型 */
  abstract cssType: 'default' | 'larger'
  /** 卡片盒子的主体的宽度 */
  '--outer-box-main-min-width'?: string
  /** 卡片盒子主体的高度 */
  '--outer-box-main-min-height'?: string
}

/** 方型卡片外层的cssVar接口 */
export type _OuterBoxCssVar = GetCssVarByClass<_OuterBoxBase>
